import { Typography } from '@mui/material';

import SkeletonLoader from './SkeletonLoader';
import { AppGridContainer, AppGridContent } from '../app-grid';

//
//

interface Props {
  isLoading: boolean;
  hasData: any;
  text?: string;
  Placeholder?: any;
  height?: number;
  hideInfo?: boolean;
  children: JSX.Element | JSX.Element[];
}

const SkeletonNoData: React.FC<Props> = ({
  isLoading,
  hasData,
  text,
  Placeholder,
  height,
  hideInfo,
  children,
}) => {
  if (isLoading) {
    return (
      <SkeletonLoader
        height={height || 300}
        sx={{ m: 0, '& .MuiSkeleton-root': { borderRadius: 0 } }}
      />
    );
  }

  return (
    <>
      {!isLoading && !hasData ? (
        <>
          {hideInfo && Placeholder ? (
            <Placeholder />
          ) : (
            <AppGridContainer
              container
              spacing={{ sm: 4 }}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                py: { xs: 4, md: 8 },
                px: 2,
                flex: 1
              }}
            >
              <AppGridContent size={{ xs: 12, sm: Placeholder ? 7 : 12 }} textAlign="center">
                <Typography variant="h4" gutterBottom>No data yet</Typography>
                {text && <Typography>{text}</Typography>}
              </AppGridContent>
              {Placeholder && (
                <AppGridContent
                  size={{ xs: 12, sm: 5 }}
                  display="flex"
                  justifyContent="flex-end"
                  sx={{ width: '100%' }}
                >
                  <Placeholder />
                </AppGridContent>
              )}
            </AppGridContainer>
          )}
        </>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default SkeletonNoData;
